import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';

// dd/mm/yyyy
const mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];

export default {
    mask: mask,
    guide: false,
    pipe: createAutoCorrectedDatePipe('dd/mm/yyyy'),
    keepCharPositions: true,
    placeholderChar: '\u2000',
};
